import React, { useEffect, useRef, useState } from "react";

// Calm green swirl wrapped in slow smoke; the smoke stirs and billows as the Coach (or you) speaks.
export const CoachOrb = ({ audioEl, env, speaking, micLevel = 0 }) => {
  const [lv, setLv] = useState(0);
  const turb = useRef(null); const disp = useRef(null); const turb2 = useRef(null); const disp2 = useRef(null);
  const live = useRef({});
  live.current = { audioEl, env, speaking, micLevel };
  useEffect(() => {
    let cur = 0; let raf; const t0 = performance.now(); let last = 0;
    const tick = (now) => {
      const { audioEl: a, env: e, speaking: sp, micLevel: mic } = live.current;
      let target = mic;
      if (sp && e?.length && a && !a.paused) target = (e[Math.floor((a.currentTime + 0.06) * 25)] || 0) / 100;
      cur += (target - cur) * (target > cur ? 0.35 : 0.08);
      const t = (now - t0) / 1000;
      const f1 = 0.009 + 0.0025 * Math.sin(t * 0.21) + cur * 0.004;
      turb.current?.setAttribute("baseFrequency", `${f1.toFixed(5)} ${(f1 * 1.6).toFixed(5)}`);
      disp.current?.setAttribute("scale", (38 + cur * 120 + 10 * Math.sin(t * 0.5)).toFixed(1));
      const f2 = 0.014 + 0.003 * Math.sin(t * 0.17 + 1);
      turb2.current?.setAttribute("baseFrequency", `${f2.toFixed(5)} ${(f2 * 0.8).toFixed(5)}`);
      disp2.current?.setAttribute("scale", (22 + cur * 70).toFixed(1));
      if (now - last > 50) { last = now; setLv(cur); }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="absolute inset-0 flex items-center justify-center" data-testid="coach-orb">
      <svg width="0" height="0" className="absolute" aria-hidden>
        <filter id="orbSmoke" x="-50%" y="-50%" width="200%" height="200%">
          <feTurbulence ref={turb} type="fractalNoise" baseFrequency="0.009 0.014" numOctaves="3" seed="7" result="n" />
          <feDisplacementMap ref={disp} in="SourceGraphic" in2="n" scale="40" xChannelSelector="R" yChannelSelector="G" />
          <feGaussianBlur stdDeviation="4" />
        </filter>
        <filter id="orbSwirl" x="-30%" y="-30%" width="160%" height="160%">
          <feTurbulence ref={turb2} type="fractalNoise" baseFrequency="0.014 0.011" numOctaves="2" seed="3" result="n" />
          <feDisplacementMap ref={disp2} in="SourceGraphic" in2="n" scale="22" xChannelSelector="G" yChannelSelector="B" />
        </filter>
      </svg>
      <style>{"@keyframes orbSpin{to{transform:rotate(360deg)}}@keyframes orbSpinR{to{transform:rotate(-360deg)}}@keyframes orbBreath{0%,100%{transform:scale(.96)}50%{transform:scale(1.04)}}"}</style>
      <div className="relative w-[68vmin] h-[68vmin] max-w-[440px] max-h-[440px]" style={{ animation: "orbBreath 7s ease-in-out infinite" }}>
        <div className="absolute inset-0" style={{ transform: `scale(${1 + lv * 0.14})`, transition: "transform 90ms linear" }}>
          <div className="absolute -inset-[40%]" style={{ filter: "url(#orbSmoke)", opacity: 0.8 + lv * 0.2, animation: "orbSpinR 40s linear infinite" }} data-testid="coach-orb-smoke">
            <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(90,210,180,0.7) 20%, rgba(40,150,135,0.42) 36%, rgba(20,80,75,0.22) 50%, transparent 66%)" }} />
            <div className="absolute inset-[18%]" style={{ background: "radial-gradient(circle at 35% 40%, rgba(150,240,210,0.35), transparent 45%), radial-gradient(circle at 68% 62%, rgba(40,150,150,0.4), transparent 50%)" }} />
          </div>
          <div className="absolute inset-0 rounded-full overflow-hidden" style={{ boxShadow: "inset 0 0 60px rgba(0,0,0,0.55)" }}>
            <div className="absolute -inset-1/4" style={{ background: "conic-gradient(from 0deg, #0b3b33, #1e8f78, #0a2a2c, #42c2a6, #114d44, #0b3b33)", filter: "url(#orbSwirl) blur(14px)", animation: "orbSpin 16s linear infinite" }} />
            <div className="absolute -inset-1/4 mix-blend-screen" style={{ background: "conic-gradient(from 120deg, transparent, rgba(120,230,200,0.35), transparent 40%, rgba(30,120,140,0.4), transparent 75%)", filter: "blur(18px)", animation: "orbSpinR 11s linear infinite" }} />
            <div className="absolute inset-[22%] rounded-full" style={{ background: "radial-gradient(circle, rgba(200,255,235,0.55), rgba(60,190,160,0.15) 55%, transparent 72%)", filter: "blur(10px)", opacity: 0.45 + lv * 0.55 }} />
          </div>
        </div>
      </div>
    </div>
  );
};
